import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService } from '../../_services/';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-import-export',
  templateUrl: './import-export.component.html',
  styleUrls: ['./import-export.component.scss']
})
export class ImportExportComponent implements OnInit {
  importExportForm:FormGroup;
  URLForm : FormGroup;
  exportedData:any =[];
  importData:any =[];
  successMsg:String ='';
  errMsg:String ='';
  importURL:{id:String,rs2_contact_ids_url:String,rs2_contact_details_url:String, rs2_projects_ids_url: String, rs2_projects_details_url : String, rs2_events_ids_url:String,rs2_events_details_url:String }[]=[];
  private subscription: Subscription;
  private subscription2: Subscription;

  constructor(
    private fb: FormBuilder,
    private _common : CommonService,
    private _admin : AdminService,
    private _alert : AlertService
  ) { }

  ngOnInit() {
    this.getImportUrls();
    this.importExportForm = this.fb.group({
      collection: [null, []],
      data: [null, []]
    }) 

    this.URLForm = this.fb.group({
      rs2_contact_ids_url: [null, []],
      rs2_contact_details_url: [null, []],
      rs2_projects_ids_url : [null, []],
      rs2_projects_details_url : [null, []],
      rs2_events_ids_url: [null, []],
      rs2_events_details_url: [null, []]
    }) 

  }
  // get import urls
  getImportUrls(){
    this._common.showLoader(true);
    this.subscription = this._admin.getImportUrls().subscribe(result=>{
      this._common.showLoader(false);
      for(let i=0;i<result.length;i++){
        this.importURL.push({id:result[i].payload.doc.id, ...result[i].payload.doc.data()});
      }
      if(this.importURL.length>0){
        this.URLForm.patchValue({ 
          rs2_contact_ids_url : this.importURL.filter(item=>item.id=='rs2_contact_ids_url').length>0?this.importURL.filter(item=>item.id=='rs2_contact_ids_url')[0].rs2_contact_ids_url:'',
          rs2_contact_details_url : this.importURL.filter(item=>item.id=='rs2_contact_details_url')[0].rs2_contact_details_url,
          rs2_projects_ids_url : this.importURL.filter(item=>item.id=='rs2_projects_ids_url')[0].rs2_projects_ids_url,
          rs2_projects_details_url : this.importURL.filter(item=>item.id=='rs2_projects_details_url')[0].rs2_projects_details_url,    
          rs2_events_ids_url : this.importURL.filter(item=>item.id=='rs2_events_ids_url')[0].rs2_events_ids_url,
          rs2_events_details_url : this.importURL.filter(item=>item.id=='rs2_events_details_url')[0].rs2_events_details_url,
        })
      }
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  insertData(){
    // return new Promise((resolve,reject)=>{
    //   this._admin.importData(form,collectionName).then(res=>{
    //     resolve(res);
    //   }).catch(err=>{
    //     reject(err);
    //   })
    // })
  }

  onFormSubmit(type){
    this.exportedData = [];
    this.errMsg = "";
    this.successMsg = "";
    const form = this.importExportForm.value;

    if(type===1){
      try{
        this.importData = JSON.parse(form.data);
        for(let i=0; i<this.importData.length;i++){
          this._admin.importData(this.importData[i],form.collection).then(res=>{
            if(i+1===this.importData.length){
              this.successMsg = "Data imported successfully!"
            }
          }).catch(err=>{
            this.errMsg = "Something went wrong while importing data";
          })

        }
      }
      catch(err) {
        
        this.errMsg = "Entered Data is not in correct format, Please check";
      }
    }
    else {
      this.importExportForm.patchValue({ 
        data : ""
      })
      this.subscription2 = this._admin.exportData(form.collection).subscribe(res=>{
        this.exportedData = res.map(item=> item.payload.doc.data());
        if(this.exportedData.length===0){
          this.errMsg = 'It seems there is no record for the entered collection or re-check the name entered';
        }
        else {
          this.importExportForm.patchValue({
            data : JSON.stringify(this.exportedData)
          })
        }
      },err=>{
        this.errMsg = 'Error occured while exporting data';
      })
    }
  }


  // Submit URL form data
  onFormSubmit2(){
    this._common.showLoader(true);
    const form = this.URLForm.value;
    this._admin.updateImportURL({rs2_contact_ids_url:form.rs2_contact_ids_url},"rs2_contact_ids_url").then(res => {
      this._admin.updateImportURL({rs2_contact_details_url:form.rs2_contact_details_url},"rs2_contact_details_url").then(res => {
        this._admin.updateImportURL({rs2_projects_ids_url:form.rs2_projects_ids_url},"rs2_projects_ids_url").then(res => {
          this._admin.updateImportURL({rs2_projects_details_url:form.rs2_projects_details_url},"rs2_projects_details_url").then(res => {
            this._admin.updateImportURL({rs2_events_ids_url:form.rs2_events_ids_url},"rs2_events_ids_url").then(res => {
              this._admin.updateImportURL({rs2_events_details_url:form.rs2_events_details_url},"rs2_events_details_url").then(res => {
                this._common.showLoader(false);
                this.successMsg = "Import Urls updated successfully!";
                this.URLForm.patchValue({
                  rs2_contact_ids_url : form.rs2_contact_ids_url,
                  rs2_contact_details_url : form.rs2_contact_details_url,
                  rs2_projects_ids_url : form.rs2_projects_ids_url,
                  rs2_projects_details_url : form.rs2_projects_details_url,
                  rs2_events_ids_url : form.rs2_events_ids_url,
                  rs2_events_details_url : form.rs2_events_details_url
                })
              },err=>{
                this._common.showLoader(false);
                this.errMsg = "Something went wrong";
              }) 
            },err=>{
              this._common.showLoader(false);
              this.errMsg = "Something went wrong";
            })           
          },err=>{
            this._common.showLoader(false);
            this.errMsg = "Something went wrong";
          })  
        },err=>{
          this._common.showLoader(false);
          this.errMsg = "Something went wrong";
        })  
      },err=>{
        this._common.showLoader(false);
        this.errMsg = "Something went wrong";
      })
    },err=>{
      this._common.showLoader(false);
      this.errMsg = "Something went wrong";
    })    
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
  }


}


